<template>
	<div class="select-color">
		<p class="title">Selecciona una paleta de colores</p>
		<v-layout wrap class="wrapper-colors">
			<v-flex xs12 md6 v-for="item in colors" :key="item.id" px-1>
				<button 
					class="btn-color"
					type="button"
					:class="{'select': item.id === colorId}"
					@click="selectColor(item)"
					>
					<v-layout>
						<v-flex xs3>
							<div 
								:style="`background-color: ${item.colorOne}`"
								class="color">
							</div>
						</v-flex>
						<v-flex xs3>
							<div 
								:style="`background-color: ${item.colorTwo}`"
								class="color">
							</div>
						</v-flex>
						<v-flex xs3>
							<div 
								:style="`background-color: ${item.colorThree}`"
								class="color border">
							</div>
						</v-flex>
						<v-flex xs3>
							<div 
							:style="`background-color: ${item.colorFour}`"
							class="color">
						</div>
						</v-flex>
					</v-layout>
				</button>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>

function selectColor(item) {
	this.colorId = item.id;
	this.$emit('change-color', item);
}

function data() {
	return {
		colors: [
			{
				id: 1,
				colorOne: '#02979b',
				colorTwo: '#b1dc03',
				colorThree: '#ffffff',
				colorFour: '#4d4d4d',
			},
			{
				id: 2,
				colorOne: '#007ec9',
				colorTwo: '#ffb700',
				colorThree: '#ffffff',
				colorFour: '#4d4d4d',
			},
			{
				id: 3,
				colorOne: '#f01d1d',
				colorTwo: '#2266aa',
				colorThree: '#ffffff',
				colorFour: '#4d4d4d',
			},
			{
				id: 4,
				colorOne: '#f26a00',
				colorTwo: '#02979b',
				colorThree: '#ffffff',
				colorFour: '#4d4d4d',
			},
		],
		colorId: 4,
	};
}
export default {
	name: 'select-color',
	data,
	methods: {
		selectColor,
	},
};
</script>
<style lang="scss" scoped>
	.color {
		border-radius: 50%;
		height: 32px;
		margin: auto;
		width: 32px;
	}

	.border {
		border: 1px solid color(border);
	}

	.btn-color {
		border: 1px solid color(border);
		border-radius: 9px;
		padding: 13px 0;
		margin-bottom: 10px;
		width: 100%;

		&:hover, &.select {
			border: 1px solid color(back-green);
		}
	}

	.title {
		color: color(info-text);
		font-size: 17px !important;
		font-weight: 600;
	}

	.select-color {
		margin: 36px 0 46px 0;
	}

	.wrapper-colors {
		@media (max-width: 959px) {
			padding: 0 30px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/select-color.vue